import {TR} from './TR';
export class TypeTableauLibre {

	public tr: TR[];

	constructor() { 
		 		this.tr = null;
 
	}
}
